// EditorReducer.js

import { ADD_PAGE, DELETE_PAGE, ADD_ROW, UPDATE_ROW, DELETE_ROW, EDIT_PAGE, EDIT_DOCUMENT_NAME, ADD_DOCUMENT, UPDATE_DOCUMENT, EDIT_DOCUMENT_ID, DELETE_DOCUMENT, SAVED_CHANGE, FIND_DOCUMENT_BY_ID } from "./editorActions";

const EditorReducer = (state = initialState, action) => {
    switch (action.type) {

        case ADD_DOCUMENT:
            return {
                ...state,
                documents: [...state.documents, { ...action.payload, hasUnsavedChanges: false }],
            };

        case UPDATE_DOCUMENT:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? { ...action.payload.updatedDocument, hasUnsavedChanges: false }
                        : doc
                ),
            };

        case ADD_PAGE:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? {
                            ...doc,
                            pages: [...doc.pages, { id: `page${doc.pages.length + 1}`, text: '' }],
                        }
                        : doc
                ),
            };

        case EDIT_PAGE:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? {
                            ...doc,
                            hasUnsavedChanges: true,
                            pages: doc.pages.map((page) =>
                                page.id === action.payload.pageId
                                    ? {
                                        ...page,
                                        text: action.payload.text,
                                    }
                                    : page
                            ),
                        }
                        : doc
                ),
            };

        case SAVED_CHANGE:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId ? {
                        ...doc,
                        hasUnsavedChanges: false,
                    } : doc
                ),
            };

        case DELETE_PAGE:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? {
                            ...doc,
                            pages: doc.pages.filter((page) => page.id !== action.payload.pageId).map((page, index) => ({
                                ...page,
                                id: `page${index + 1}`,
                            })),
                        }
                        : doc
                ),
            };

        case EDIT_DOCUMENT_NAME:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? {
                            ...doc,
                            name: action.payload.name,
                        }
                        : doc
                ),
            };

        case DELETE_DOCUMENT:
            return {
                ...state,
                documents: state.documents.filter((doc) => doc.id !== action.payload.documentId),
            };

        case EDIT_DOCUMENT_ID:
            return {
                ...state,
                documents: state.documents.map((doc) =>
                    doc.id === action.payload.documentId
                        ? {
                            ...doc,
                            id: action.payload.newId,
                        }
                        : doc
                ),
            };

        case FIND_DOCUMENT_BY_ID:
            return {
                ...state,
                documents: state.documents.map((doc) => doc.id === action.payload.documentId ? { ...doc, content: action.payload.content } : doc)
            };

        default:
            return state;
    }
};

export default EditorReducer;
